import { render, staticRenderFns } from "./CompanyDetailsHeader.vue?vue&type=template&id=2ccef025&scoped=true&"
import script from "./CompanyDetailsHeader.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetailsHeader.vue?vue&type=style&index=0&id=2ccef025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccef025",
  null
  
)

export default component.exports